<div class="modal fade" id="modalDuplicateCatalogVersion" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="fa-solid fa-clone me-2"></i> Duplicar versión de catálogo
                </h5>
                <button type="button" class="btn-close" (click)="close()"></button>
            </div>

            <div class="modal-body step-content">

                <div class="version-summary-card mb-4" *ngIf="currentVersion">
                    <div class="d-flex align-items-center mb-3">
                        <div class="cover-thumb custom-class me-3">
                         <img [src]="fileBaseUrl + '/' + currentVersion.coverFileId" [alt]="'me-3 shadow-sm'" (click)="imagePreview.openModal(fileBaseUrl + '/' + currentVersion.coverFileId!)" />
                        </div>
                        <div>
                            <h5 class="mb-1">{{ currentVersion.title || '—' }}</h5>
                            <p class="text-muted small mb-0">{{ currentVersion.subtitle || '—' }}</p>
                            <span class="badge bg-primary me-1">Versión #{{ currentVersion.versionNumber }}</span>
                            <span class="badge" [ngClass]="{
                                'bg-success': currentVersion.statusCode === 'Published',
                                'bg-secondary': currentVersion.statusCode !== 'Published'
                            }">
                                {{ currentVersion.statusName }}
                            </span>

                        </div>
                    </div>

                    <p class="short-desc">{{ currentVersion.shortDescription }}</p>

                    <div class="row small text-muted mt-3">
                        <div class="col-md-6">
                            <strong>Tipo:</strong> {{ currentVersion.functionalTypeName || '—' }}
                        </div>
                        <div class="col-md-6">
                            <strong>Servicio:</strong> {{ currentVersion.availableServiceName || '—' }}
                        </div>
                        <div class="col-md-6">
                            <strong>Creado por:</strong> {{ currentVersion.createdByName }}
                            ({{ currentVersion.createdAt | date:'dd/MM/yyyy hh:mm a' }})
                        </div>
                        <div class="col-md-6">
                            <strong>Publicada por:</strong> {{ currentVersion.publishedByName || '—' }}
                            <span *ngIf="currentVersion?.publishedAt">
                                ({{ currentVersion.publishedAt | date:'dd/MM/yyyy hh:mm a' }})
                            </span>
                        </div>
                    </div>

                    <div class="mt-3 d-flex justify-content-end">
                        <button class="btn btn-outline-primary btn-sm" (click)="viewVersion(currentVersion)">
                            <i class="fa-solid fa-eye me-1"></i> Ver más detalles
                        </button>
                    </div>
                </div>

                <!-- Formulario -->
                <form [formGroup]="form" class="row g-4">

                    <!-- Título -->
                    <div class="form-group col-12">
                        <label class="required-field">Título</label>
                        <input type="text" class="form-control" formControlName="title"
                            placeholder="Ej: Catálogo duplicado"
                            [ngClass]="{'is-invalid': form.get('title')?.invalid && form.get('title')?.touched}">
                        <div class="invalid-feedback" *ngIf="form.get('title')?.hasError('required')">
                            El título es obligatorio
                        </div>
                        <div class="invalid-feedback" *ngIf="form.get('title')?.hasError('maxlength')">
                            Máximo {{ form.get('title')?.errors?.['maxlength']?.requiredLength }} caracteres
                        </div>
                    </div>

                    <!-- Subtítulo -->
                    <div class="form-group col-12">
                        <label class="required-field">Subtítulo</label>
                        <input type="text" class="form-control" formControlName="subtitle"
                            placeholder="Ej: Haz que tu catálogo destaque"
                            [ngClass]="{'is-invalid': form.get('subtitle')?.invalid && form.get('subtitle')?.touched}">
                        <div class="invalid-feedback" *ngIf="form.get('subtitle')?.hasError('required')">
                            El subtítulo es obligatorio
                        </div>
                        <div class="invalid-feedback" *ngIf="form.get('subtitle')?.hasError('maxlength')">
                            Máximo {{ form.get('subtitle')?.errors?.['maxlength']?.requiredLength }} caracteres
                        </div>
                    </div>

                    <!-- Descripción corta -->
                    <div class="form-group col-12">
                        <label class="required-field">Descripción corta</label>
                        <textarea class="form-control" rows="3" formControlName="shortDescription"
                            placeholder="Resumen breve de los beneficios"
                            [ngClass]="{'is-invalid': form.get('shortDescription')?.invalid && form.get('shortDescription')?.touched}">
            </textarea>
                        <div class="invalid-feedback" *ngIf="form.get('shortDescription')?.hasError('required')">
                            Este campo es obligatorio
                        </div>
                        <div class="invalid-feedback" *ngIf="form.get('shortDescription')?.hasError('maxlength')">
                            Máximo {{ form.get('shortDescription')?.errors?.['maxlength']?.requiredLength }} caracteres
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <label>Descripción larga</label>
                        <quill-editor [modules]="quillOptions" formControlName="longDescription" [style]="{height: '150px'}"></quill-editor>
                    </div>

                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" formControlName="publishNow"
                                id="publishNow">
                            <label class="form-check-label" for="publishNow">
                                Publicar inmediatamente
                            </label>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer step-actions">
                <button class="btn btn-secondary" (click)="close()">Cancelar</button>
                <button class="btn btn-primary" (click)="submit()" [disabled]="form.invalid">Duplicar</button>
            </div>
        </div>
    </div>
</div>

<app-modal-catalog-wizard modalId="modalCatalogWizardVersionView" [showTitle]="false" />
<app-image-preview #imagePreview></app-image-preview>